import { types as t, flow } from 'mobx-state-tree';
import countryCodesApi from 'shared/api/countryCodes';

export const CountryCode = t.model('CountryCode', {
  code: t.number,
  country_id: t.string,
  country_name: t.string,
  country_iso: t.string,
});

const BaseCountryCodesModel = t.model('BaseCountryCodesModel', {});

const CountryCodesModel = t.model('CountryCodesModel', {
  countryCodes: t.optional(t.array(CountryCode), []),
});

export const CountryCodesDataModel = t
  .compose(BaseCountryCodesModel, CountryCodesModel)
  .actions(self => ({
    fetchCountryCodes: flow(function* fetchCountryCodes() {
      const response = yield countryCodesApi.getCountryCodes();
      if (response && response.data && response.data.items) {
        self.countryCodes = response.data.items as any;
      }
      return response;
    }),
  }));
